import React, { useState, useEffect, useRef } from 'react'
import { Select, Spin, message, Pagination, DatePicker } from 'antd'
import showLocationType from "../../../vietnamese/showLocationType"
import { getBasketUncomplete } from '../../../services/api/mergerApi'
import { BASKET_LOCATION, listPartner } from '../../baskets/helper/basketFilters'
import FilterOptions from '../../home/components/filters/FilterOptions'
import SearchField from '../../home/components/filters/SearchField'
import FilterDateRangeV2 from '../../shared/FilterDateRangeV2'
import { Link } from "react-router-dom"
import moment from 'moment'
import axios from 'axios'

const {RangePicker} = DatePicker

const StatisticsUncompleteBasketPage = () => {
    const [type, setType] = useState('THANK_CARD')
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [limit, setLimit] = useState(20)
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(1)
    const [location, setLocation] = useState('all')
    const [orderNumber, setOrderNumber] = useState('')
    const [basketNumber, setBasketNumber] = useState('')
    // const [created, setCreated] = useState({})
    const [created, setCreated] = useState([moment().subtract(1, 'month'), moment()])
    const [payloadCreated, setPayloadCreated] = useState({
        from: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD')
    })
    const [partner, setPartner] = useState('')
    const cancelSourceRef = useRef(null)

    const fetchData = async () => {
        // Hủy request cũ nếu vẫn đang chạy
        if (cancelSourceRef.current) {
            // console.log('Hủy request cũ')
            cancelSourceRef.current.cancel('Request bị hủy trước đó')
            await Promise.resolve()
        }

        // // Tạo token mới
        cancelSourceRef.current = axios.CancelToken.source()

        setLoading(true)
        try {
            const payload = {
                page, limit,
                type,
            }

            if (location) payload.location = location
            if (orderNumber) payload.order_number = orderNumber.replace('#', '')
            if (basketNumber) payload.basket_number = basketNumber
            if (partner) payload.partner = partner
            if (!!Object.keys(payloadCreated).length) {
                payload.from = payloadCreated.from
                payload.to = payloadCreated.to
            }

            const { data: res } = await getBasketUncomplete(payload, cancelSourceRef.current.token)
            const { data, success, message: mess } = { ...res }

            if (!success) {
                setLoading(false)
                return message.error(mess)
            }
            const { Baskets, total } = { ...data }
            setData(Baskets)
            setTotal(total)
            setLoading(false)
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('Request bị hủy')
            } else {
                message.error(error.message)
                setLoading(false)
            }
        }
    }

    useEffect(() => {
        fetchData()
    }, [type, limit, page, location, orderNumber, basketNumber, created, partner])

    const _parseTypes = (types) => {
        const vTypes = Array.isArray(types) ? types : []

        if (!vTypes.length) return ''

        if (vTypes.length <= 5) {
            return vTypes.join(', ')
        }

        const begin = vTypes.slice(0, 5)
        begin.push('...')

        return begin.join(', ')
    }

    const handleChangeFilter = (field, value) => {
        if (field === 'location') setLocation(value)
        if (field === 'order_number') setOrderNumber(value)
        if (field === 'basket_number') setBasketNumber(value)
        if (field === 'type') setType(value)
        if (field === "partner") setPartner(value)
        setPage(1)
    }

    const _handleChangeDate = (field, value) => {
        if (!!value.from && value.to) {
            setCreated({
                from: moment(value.from, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                to: moment(value.to, 'DD/MM/YYYY').format('YYYY-MM-DD')
            })
        } else {
            setCreated({})
        }
        setPage(1)
    }

    const _handleChangeDateNew = (dates) => {
        if (!!dates && dates.length === 2) {
            const date_from = moment(dates[0]).format('YYYY-MM-DD')
            const date_to = moment(dates[1]).format('YYYY-MM-DD')

            
            setCreated(dates)
            setPayloadCreated({
                from: date_from,
                to: date_to
            })
        } else {
            setCreated([moment().subtract(1, 'month'), moment() ])
            setPayloadCreated({
                from: moment().subtract(1, 'month').format('YYYY-MM-DD'),
                to: moment().format('YYYY-MM-DD')
            })
        }

        setPage(1)
    }

    const handlePageChange = (current) => {
        setPage(current)
    }

    const handleShowSizeChange = (current, size) => {
        setPage(1)
        setLimit(size)
    }

    return (
        <div className='StatisticsUncompleteBasketPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className='mt-3'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <h3>Thống kê giỏ chưa hoàn thành</h3>
                            <div className="listBtn">
                                <a className="ant-btn mr-3 ant-btn-secondary" href="/statistics-delete-basket">Thống kê xóa giỏ</a>
                                <a className="ant-btn mr-3 ant-btn-secondary" href="/statistics-add-basket">Thống kê thêm giỏ</a>
                                <a className="ant-btn ant-btn-secondary" href="/baskets">Baskets</a>
                            </div>
                        </div>
                        <div className='jumbotron p-3 mb-3'>
                            <div className='row align-items-end'>
                                <div className='d-flex flex-column col-12 col-xl-auto'>
                                    <label className='mb-1 font-weight-bold'>Type</label>
                                    <Select
                                        value={type}
                                        // disabled={loading}
                                        onChange={value => handleChangeFilter('type', value)}
                                        style={{
                                            width: 200,
                                        }}
                                    >
                                        <Select.Option value={'THANK_CARD'}>THANK CARD</Select.Option>
                                        <Select.Option value={'BRAND_KIT'}>BRAND KIT</Select.Option>
                                        <Select.Option value={'GIFTCARD_1800NO'}>GIFTCARD_1800NO</Select.Option>
                                    </Select>
                                </div>

                                <div className='col-12 col-xl-auto'>
                                    <FilterOptions onChangeOption={handleChangeFilter}
                                        defaultOption='all' field='location'
                                        options={BASKET_LOCATION} heading='Địa chỉ:' />
                                </div>

                                <div className='col-12 col-xl-auto'>
                                    <label className='d-block mb-1 font-weight-bold'>Mã đơn:</label>
                                    <SearchField field='order_number' onChangeInput={handleChangeFilter}
                                        placeholder='Tìm theo mã đơn...' />
                                </div>

                                <div className='col-12 col-xl-auto'>
                                    <label className='d-block mb-1 font-weight-bold'>Mã giỏ:</label>
                                    <SearchField field='basket_number' onChangeInput={handleChangeFilter}
                                        placeholder='Tìm theo mã giỏ...' />
                                </div>

                                <div className='col-12 col-xl-auto'>
                                    <FilterOptions onChangeOption={handleChangeFilter} defaultOption=""
                                        field='partner' options={listPartner} layout='select'
                                        heading='Partner:' />
                                </div>

                                <div className='col-12 col-xl-auto'>
                                    <label className="font-weight-bold d-block mb-1">Ngày tạo:</label>
                                    {/* <FilterDateRangeV2
                                        onDatesChange={_handleChangeDate}
                                        field='create_at'
                                        disabled={loading}
                                    /> */}

                                    <RangePicker
                                        ranges={{
                                            'Today': [moment(), moment()],
                                            'Last 7 Days': [moment().subtract(6, 'day'), moment()],
                                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                                        }}
                                        format='DD/MM/YYYY'
                                        onChange={_handleChangeDateNew}
                                        // disabled={disabled || false}
                                        value={created}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-end align-items-center mb-3 headPagination">
                            <Pagination current={page} total={total} pageSize={limit}
                                showTotal={(sum, range) => sum > 0 &&
                                    <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} items`}</strong>
                                    </div>}
                                onChange={handlePageChange}
                                className='text-right' showSizeChanger
                                pageSizeOptions={['10', '20', '50', '100']}
                                onShowSizeChange={handleShowSizeChange}
                            />
                        </div>

                        <Spin spinning={loading} tip='Loading...'>
                            <table className='table table-borderless table-striped BasketStatisticsTable'>
                                <thead className='BasketStatisticsHeader thead-light'>
                                    <tr>
                                        <th>Số giỏ</th>
                                        <th>Mã đơn</th>
                                        <th>Type</th>
                                        <th>Địa chỉ</th>
                                        <th>Ngày tạo</th>
                                    </tr>
                                </thead>
                                <tbody className="BasketStatisticsRow">
                                    {
                                        !!data && data.length > 0 && data.map((item, i) => {
                                            const { _id, location, initialized_at, number, order_number, item_types = [], status: status_basket } = { ...item }

                                            return (
                                                <tr key={_id}>
                                                    <td>
                                                        <Link to={`/baskets/${_id}`}>
                                                            {number ? number : ''}
                                                        </Link>
                                                    </td>
                                                    <td>{order_number ? `#${order_number}` : '--'}</td>
                                                    <td>{_parseTypes(item_types)}</td>
                                                    <td>{showLocationType(location)}</td>
                                                    <td>{initialized_at ? moment(initialized_at).format("HH:mm DD/MM/YYYY") : ''}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                    {
                                        !loading && (!data || data.length === 0) &&
                                        <tr>
                                            <td colSpan={5}>
                                                No result
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </Spin>

                        <Pagination current={page} total={total} pageSize={limit}
                            onChange={handlePageChange}
                            showQuickJumper
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onShowSizeChange={handleShowSizeChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StatisticsUncompleteBasketPage